import { SxProps, Theme } from '@mui/material';
import Typography from '@mui/material/Typography';

type Props = {
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  href?: string;
  children: React.ReactNode;
  color?: string;
  sx?: SxProps<Theme>;
};

export const AnchorDisplayText: React.FC<Omit<Props, 'onClick' | 'href'>> = ({
  children,
  color = 'primary.main'
}) => {
  return (
    <Typography
      variant="body2"
      color={color}
      sx={{
        textDecoration: 'underline'
      }}
    >
      {children}
    </Typography>
  );
};

export const AnchorText: React.FC<Props> = ({
  onClick,
  href,
  children,
  color = 'primary.main',
  sx
}) => {
  return (
    <Typography
      variant="body2"
      color={color}
      sx={{
        fontSize: '16px',
        textDecoration: 'underline',
        wordBreak: 'break-word', // Most aggressive breaking
        whiteSpace: 'normal', // Ensures text wraps
        maxWidth: '100%', // Constrains to parent
        display: 'inline-block', // Maintains link behavior while allowing breaks
        cursor: 'pointer',
        ...sx
      }}
      onClick={onClick}
      href={href}
      component={'a'}
    >
      {children}
    </Typography>
  );
};
